<div class="note"
    *ngFor="let note of job?.notesArr"
    [innerHTML]="note.text">
</div>
